import { Bell } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover';
import { useFeedback } from './FeedbackContext';
import { FeedbackIcon } from './FeedbackCapture';
import { navigateFeedback } from './feedbackApi';

export function FeedbackHeader() {
  const feedback = useFeedback();
  const unread = feedback.notifications.filter(n => !n.readAt).length;
  return <>
    {feedback.permissions.some(p => p.startsWith('feedback:record:read:')) && <Popover>
      <PopoverTrigger asChild><button type="button" aria-label={`Feedback notifications, ${unread} unread`} className="relative p-2 rounded-md hover:bg-accent">
        <Bell className="size-4" />{unread > 0 && <span className="absolute -top-1 -right-1 text-xs bg-red-600 text-white rounded-full px-1">{unread}</span>}
      </button></PopoverTrigger>
      <PopoverContent className="feedback-notifications mp-block" data-analytics-private><h2 className="font-semibold p-2">Feedback notifications</h2>
        {!feedback.notifications.length && <p className="p-2 text-sm">You’re all caught up.</p>}
        {feedback.notifications.map(n => <button key={n.id} type="button" onClick={() => { void feedback.readNotification(n.id); navigateFeedback('mine', n.reference); }}>
          <strong>{!n.readAt && '● '}{n.reference}</strong><p>{n.kind.replace(/_/g, ' ')}</p><small>{new Date(n.createdAt).toLocaleString()}</small>
        </button>)}
      </PopoverContent>
    </Popover>}
    {feedback.allows('feedback:record:create') && <button type="button" className="feedback-header-button" data-track-id="open_feedback" onClick={feedback.openCapture}>
      <FeedbackIcon name="header-message-square" />Feedback
    </button>}
  </>;
}
